<template>
    <div>
        <div class="loading-spinner-outer" v-if="saving_file_number > 0">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Uploading file {{ saving_file_number }} of {{ attachments.length }}, please wait
                </div>
            </div>
        </div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Sending, please wait
                </div>
            </div>
        </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Submit a case study
                </div>
            </div>
            <div class="main">
                <div class="content">

                    <p class="intro-text">
                        Use the form below to submit details of a project that you think would make a good case study.
                    </p>

                    <div class="form-sections">

                        <div class="form-section">
                            <div class="sub-title">
                                Customer Details
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Company Name</label>
                                    <input type="text" v-model="case_study.company_details_company_name" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>Main Contact Name</label>
                                    <input type="text" v-model="case_study.company_details_main_contact_name" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>Address</label>
                                    <input type="text" v-model="case_study.company_details_address" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>Website Address</label>
                                    <input type="text" v-model="case_study.company_details_website_address" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>Telephone No.</label>
                                    <input type="text" v-model="case_study.company_details_telephone_number" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>Mobile No.</label>
                                    <input type="text" v-model="case_study.company_details_mobile_number" class="form-control">
                                </div>

                                <div class="form-group mb-0">
                                    <label>Email</label>
                                    <input type="text" v-model="case_study.company_details_email" class="form-control">
                                </div>
                            </div>
                        </div>


                        <div class="form-section mt-10">
                            <div class="sub-title">
                                Project Outline
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>What is the name of the project?</label>
                                    <input type="text" v-model="case_study.project_outline_name_of_project" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>Where is it?</label>
                                    <input type="text" v-model="case_study.project_outline_where_is_it" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>Who is the customer?</label>
                                    <input type="text" v-model="case_study.project_outline_who_is_customer" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>What is being delivered?</label>
                                    <div class="radios _inline">
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.project_outline_what_is_being_delivered" value="New Build">
                                            <span class="radio-label">
                                        New Build
                                    </span>
                                        </label>
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.project_outline_what_is_being_delivered" value="Refurb">
                                            <span class="radio-label">
                                        Refurb
                                    </span>
                                        </label>
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.project_outline_what_is_being_delivered" value="Other">
                                            <span class="radio-label">Other (please specify)</span>
                                        </label>
                                    </div>
                                    <input type="text" v-if="case_study.project_outline_what_is_being_delivered === 'Other'" v-model="case_study.project_outline_what_is_being_delivered_other"
                                           class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>How many windows and doors are being installed?</label>
                                    <input type="text" v-model="case_study.project_outline_how_many_windows_and_doors" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>What is the time frame?</label>
                                    <input type="text" v-model="case_study.project_outline_time_frame" class="form-control">
                                </div>

                                <div class="form-group">
                                    <label>When does (did) it start?</label>
                                    <input type="text" v-model="case_study.project_outline_start_date" class="form-control">
                                </div>

                                <div class="form-group mb-0">
                                    <label>When does (did) it end?</label>
                                    <input type="text" v-model="case_study.project_outline_end_date" class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="form-section mt-10 _what-products">

                            <div class="sub-title">
                                What product(s) is the project using?
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Windows</label>
                                    <div class="checkboxes _inline">
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_windows" value="Casement">
                                            <span class="checkbox-label">
                                        Casement
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_windows" value="Flush Casement">
                                            <span class="checkbox-label">
                                        Flush Casement
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_windows" value="Tilt & Turn">
                                            <span class="checkbox-label">
                                        Tilt & Turn
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_windows" value="Flush Tilt & Turn">
                                            <span class="checkbox-label">
                                        Flush Tilt & Turn
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_windows" value="Fully Reversible">
                                            <span class="checkbox-label">
                                        Fully Reversible
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_windows" value="Vertical Slider">
                                            <span class="checkbox-label">
                                        Vertical Slider
                                    </span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Doors</label>
                                    <div class="checkboxes _inline">
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_doors" value="Residential Door">
                                            <span class="checkbox-label">
                                        Residential Door
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_doors" value="Composite Door">
                                            <span class="checkbox-label">
                                        Composite Door
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_doors" value="French Door">
                                            <span class="checkbox-label">
                                        French Door
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_doors" value="Emergency Door">
                                            <span class="checkbox-label">
                                        Emergency Door
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_doors" value="Sliding Door">
                                            <span class="checkbox-label">
                                        Sliding Door
                                    </span>
                                        </label>
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_doors" value="Bifold Door">
                                            <span class="checkbox-label">
                                        Bifold Door
                                    </span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group mb-0">
                                    <label>Other</label>
                                    <div class="checkboxes _inline">
                                        <label class="checkbox">
                                            <input type="checkbox" v-model="case_study.products_other" value="Curtain Wall System">
                                            <span class="checkbox-label">
                                        Curtain Wall System
                                    </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section mt-10">
                            <div class="sub-title">
                                Questionnaire
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Have their been any particular challenges in project delivery and how were they overcome?</label>
                                    <textarea class="form-control" rows="10" v-model="case_study.questionnaire_challenges_that_were_overcome">
                                    </textarea>
                                </div>

                                <div class="form-group">
                                    <label>What benefits has the project delivered to the customer?</label>
                                    <textarea class="form-control" rows="10" v-model="case_study.questionnaire_benefits_to_customer">
                                    </textarea>
                                </div>

                                <div class="form-group mb-0">
                                    <label>Upload Images</label>
                                    <div class="full-width">
                                        <form :action="`${$aws_upload_url}`" method="post"
                                              enctype="multipart/form-data" id="amazon_form">
                                            <input type="hidden" name="policy" :value="aws_policy">
                                            <input type="hidden" name="x-amz-algorithm" value="AWS4-HMAC-SHA256">
                                            <input type="hidden" name="x-amz-credential" :value="aws_credential">
                                            <input type="hidden" name="x-amz-date" :value="aws_date">
                                            <input type="hidden" name="x-amz-signature" :value="aws_signature">
                                            <input type="hidden" name="acl" value="private">
                                        </form>
                                        <vue-dropzone
                                                ref="fileUploadDropzone"
                                                id="dropzone"
                                                :options="dropzoneOptions"
                                                v-on:vdropzone-file-added="fileAddedToDropZone"
                                                v-on:vdropzone-removed-file="fileRemovedFromDropZone"
                                                :useCustomSlot="true"
                                        >
                                            <div>
                                                <div class="mb-3">
                                                    DRAG AND DROP FILES
                                                </div>
                                                <div class="mb-3">
                                                    OR
                                                </div>
                                                <div>
                                                    <a class="btn-secondary-outline">
                                                        Choose files
                                                    </a>
                                                </div>
                                            </div>
                                        </vue-dropzone>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-section mt-10">
                            <div class="sub-title">
                                Consent
                            </div>
                            <div class="inputs">
                                <div class="form-group">
                                    <label>Are you happy for us to promote on our digital commercial platforms:</label>
                                    <div class="radios _inline">
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.consent_digital_platforms" value="Yes">
                                            <span class="radio-label">
                                                Yes
                                            </span>
                                        </label>
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.consent_digital_platforms" value="No">
                                            <span class="radio-label">
                                             No
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label>Are you happy for us to promote in the fenestration press:</label>
                                    <div class="radios _inline">
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.consent_fenestration_press" value="Yes">
                                            <span class="radio-label">
                                                Yes
                                            </span>
                                        </label>
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.consent_fenestration_press" value="No">
                                            <span class="radio-label">
                                                No
                                            </span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group mb-0">
                                    <label>Are you happy for us to promote across social media:</label>
                                    <div class="radios _inline">
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.consent_social_media" value="Yes">
                                            <span class="radio-label">
                                                Yes
                                            </span>
                                        </label>
                                        <label class="radio">
                                            <input type="radio" v-model="case_study.consent_social_media" value="No">
                                            <span class="radio-label">
                                                No
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="align-right mt-10">
                        <div class="btn-primary" @click.stop="save()">
                            Submit Case Study
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box mt-6" v-if="case_studies.length > 0">
            <div class="box-content">
                <h3 class="txt-primary">
                    Your Previous Submissions
                </h3>
                <table class="table _lined">
                    <thead>
                    <tr>
                        <th>Date Sent</th>
                        <th>Project Name</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(case_study, index) in case_studies">
                        <td>
                            {{ case_study.friendly_created_at }}
                        </td>
                        <td>
                            {{ case_study.project_name }}
                        </td>
                        <td class="align-right">
                            <a :href='"/commercial/case-studies/"+case_study.id' class="txt-primary">
                                <i class="fa fa-eye"></i>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <template>
                    <div class="pagination-bar wrapper mb-3 mt-3">
                        <div class="row">
                            <div class="col">
                                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                        class="fa fa-caret-left"></i></a>
                                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                            </div>
                            <div class="col align-right">
                                <div class="mt-1 mb-1">
                                    {{ total_count }} results found
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone';

  export default {
    mounted() {
      this.loadCaseStudies();
    },
    components: {
      'vue-dropzone': vue2Dropzone,
    },
    props: {
      'logged_in_user': {
        required: true,
      },
      'aws_policy': {
        required: true,
      },
      'aws_credential': {
        required: true,
      },
      'aws_date': {
        required: true,
      },
      'aws_signature': {
        required: true,
      },
    },
    data() {
      return {
        case_studies: [],
        current_page: 1,
        total_count: 0,
        total_pages: 0,
        limit: 20,
        saving_file_number: 0,
        attachments: [],
        attachment_info: [],
        saving: false,
        dropzoneOptions: {
          url: '/',
          autoProcessQueue: false,
          uploadMultiple: true,
          addRemoveLinks: true,
        },
        case_study: {
          products_windows: [],
          products_doors: [],
          products_other: [],
        },
      }
    },
    methods: {
      loadCaseStudies() {
        axios.post('/commercial/case-studies/loadCaseStudiesForUser', {
          page_number: this.current_page,
          limit: this.limit,
        }).then((response) => {
          this.case_studies = response.data.data;
          this.total_count = response.data.total;
          this.total_pages = response.data.last_page;
        });
      },
      prevPage() {
        this.current_page = this.current_page - 1;
        this.loadCaseStudies();
      },
      nextPage() {
        this.current_page = this.current_page + 1;
        this.loadCaseStudies();
      },
      fileAddedToDropZone(uploadedFile) {
        const extension = uploadedFile.name.replace(/^.*\./, '');
        const original_file_name = uploadedFile.name.replace('.' + extension, '')
        .replace(' ', '_')
        .toLowerCase();

        const allowed_extensions = [
          'jpg', 'jpeg', 'png', 'svg', 'gif', 'bmp',
        ];

        if (!allowed_extensions.includes(extension.toLowerCase())) {
          this.$refs.fileUploadDropzone.dropzone.removeFile(uploadedFile);
          Swal.fire({
            title: 'Invalid File Type',
            icon: 'error',
            text: 'File type not allowed, please ensure the file is one of the following formats: \'jpg\', \'jpeg\', \'png\',  \'svg\', \'gif\', \'bmp\''
          });
          return;
        }

        const filename = 'case_study_attachments/' + original_file_name + '_' + Date.now();

        const new_file = {
          file: uploadedFile,
          filename: filename + '.' + extension,
          filetype: uploadedFile.type,
          original_file_name: original_file_name,
        };

        this.attachments.push(new_file);
        this.attachment_info.push({
          original_file_name: new_file.original_file_name,
          filename: new_file.filename,
        });
      },
      fileRemovedFromDropZone(file) {
        const extension = file.name.replace(/^.*\./, '');
        const original_file_name = file.name.replace('.' + extension, '');
        this.attachments = this.attachments.filter(attachment => attachment.original_file_name !== original_file_name);
        this.attachment_info = this.attachment_info.filter(attachment => attachment.original_file_name !== original_file_name);
      },
      async save() {

        const validationErrors = Validate({
          company_name: this.case_study.company_details_company_name,
          main_contact_name: this.case_study.company_details_main_contact_name,
          address: this.case_study.company_details_address,
          website_address: this.case_study.company_details_website_address,
          telephone_number: this.case_study.company_details_telephone_number,
          mobile_number: this.case_study.company_details_mobile_number,
          email: this.case_study.company_details_email,
          project_name: this.case_study.project_outline_name_of_project,
          where_is_the_project: this.case_study.project_outline_where_is_it,
          who_is_the_customer: this.case_study.project_outline_who_is_customer,
          what_is_being_delivered: this.case_study.project_outline_what_is_being_delivered,
          how_many_door_and_windows_are_being_installed: this.case_study.project_outline_how_many_windows_and_doors,
          time_frame: this.case_study.project_outline_time_frame,
          start_date: this.case_study.project_outline_start_date,
          end_date: this.case_study.project_outline_end_date,
          any_challenges_that_were_overcome: this.case_study.questionnaire_challenges_that_were_overcome,
          what_benefits_has_the_project_delivered: this.case_study.questionnaire_benefits_to_customer,
          choose_digital_platform_consent: this.case_study.consent_digital_platforms,
          choose_fenestration_press_consent: this.case_study.consent_fenestration_press,
          choose_social_media_consent: this.case_study.consent_social_media,
        }, {
          company_name: {
            presence: {
              allowEmpty: false,
            },
          },
          main_contact_name: {
            presence: {
              allowEmpty: false,
            },
          },
          address: {
            presence: {
              allowEmpty: false,
            },
          },
          website_address: {
            presence: {
              allowEmpty: false,
            },
          },
          telephone_number: {
            presence: {
              allowEmpty: false,
            },
          },
          mobile_number: {
            presence: {
              allowEmpty: false,
            },
          },
          email: {
            presence: {
              allowEmpty: false,
            },
            email: true,
          },
          project_name: {
            presence: {
              allowEmpty: false,
            },
          },
          where_is_the_project: {
            presence: {
              allowEmpty: false,
            },
          },
          who_is_the_customer: {
            presence: {
              allowEmpty: false,
            },
          },
          what_is_being_delivered: {
            presence: {
              allowEmpty: false,
            },
          },
          how_many_door_and_windows_are_being_installed: {
            presence: {
              allowEmpty: false,
            },
          },
          time_frame: {
            presence: {
              allowEmpty: false,
            },
          },
          start_date: {
            presence: {
              allowEmpty: false,
            },
          },
          end_date: {
            presence: {
              allowEmpty: false,
            },
          },
          any_challenges_that_were_overcome: {
            presence: {
              allowEmpty: false,
            },
          },
          what_benefits_has_the_project_delivered: {
            presence: {
              allowEmpty: false,
            },
          },
          choose_digital_platform_consent: {
            presence: {
              allowEmpty: false,
            },
          },
          choose_fenestration_press_consent: {
            presence: {
              allowEmpty: false,
            },
          },
          choose_social_media_consent: {
            presence: {
              allowEmpty: false,
            },
          },
        });

        if (validationErrors) {
          this.saving = false;
          Swal.fire({
            title: 'Unable to send case study',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        if (this.attachments.length < 1) {
          this.sendCaseStudy();
          return;
        }

        this.saving_file_number = 1;

        await this.attachments.forEach(async (upload, index) => {
          let form_data = new FormData(document.querySelector('#amazon_form'));
          form_data.append('Content-Type', upload.filetype);
          form_data.append('key', upload.filename);
          form_data.append('file', upload.file);

          await axios({
            method: 'post',
            url: this.$aws_upload_url,
            data: form_data,
            headers: {'Content-Type': 'multipart/form-data'}
          }).then(async () => {
            if (this.saving_file_number === this.attachments.length) {
              this.saving_file_number = 0;
              this.$refs.fileUploadDropzone.dropzone.removeAllFiles();
              this.sendCaseStudy();
            } else {
              this.saving_file_number = this.saving_file_number + 1;
            }
          });
        });

      },
      async sendCaseStudy() {

        this.saving = true;

        axios.post('/commercial/case-studies/create', {
          'case_study': this.case_study,
          'attachments': this.attachment_info,
        }).then((response) => {
          this.saving = false;
          this.case_study = {};
          this.attachments = [];
          this.attachment_info = [];
          this.loadCaseStudies();

          Swal.fire({
            title: 'Case Study Sent',
            icon: 'success',
            text: 'Your Case Study has been sent.'
          });

        });
      },
      attachmentUrl(attachment) {
        return {'backgroundImage': `url('${this.$aws_bucket_url}${attachment.file_url}')`};
      },
    },
  };
</script>
